let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
import styled, { css } from 'styled-components';
import { colors } from '@ovpn-ui/styles';
import { shadows } from '../../../styles';
import Box from '../../../Box';
const affixStyle = () => css(_t || (_t = _`
        display: flex;

        align-items: center;

        padding: 8px;

        color: ${0};

        line-height: 24px;

        white-space: nowrap;

        text-align: center;

        background-color: ${0};

        cursor: pointer;
    `), colors.neutralTextBody, colors.neutralBg);
const errorStateStyle = ({
  $focused
}) => css(_t2 || (_t2 = _`
    &,
    &:hover {
        border: 1px solid ${0};
    }

    ${0}

    .ovpn-input-suffix,
    .ovpn-input-prefix,
    .ovpn-input-leading-icon,
    .ovpn-input-trailing-icon {
        color: ${0};
    }
`), colors.warningBaseHover, $focused && css(_t3 || (_t3 = _`
        &,
        &:hover {
            box-shadow: ${0};
        }
    `), shadows.focusedError), colors.warningBaseHover);
const selectContainerStateStyles = ({
  $disabled,
  $focused,
  $error
}) => {
  if ($disabled) {
    return css(_t4 || (_t4 = _`
            background-color: ${0};

            cursor: not-allowed;

            pointer-events: none;

            .ovpn-input-suffix,
            .ovpn-input-prefix {
                color: ${0};
            }

            svg {
                color: ${0};
            }
        `), colors.neutralBg, colors.neutralTextBody, colors.neutralTextBody);
  }
  if ($error) {
    return css(_t5 || (_t5 = _`
            ${0}
        `), errorStateStyle({
      $focused
    }));
  }
  if ($focused) {
    return css(_t6 || (_t6 = _`
            &,
            &:hover {
                border: 1px solid ${0};
                box-shadow: ${0};
            }
        `), colors.neutralBorderHover, shadows.focusedBlue);
  }
  return '';
};
export const Container = styled(Box)(_t7 || (_t7 = _`
    justify-content: flex-end;

    box-sizing: border-box;

    height: 40px;

    overflow: hidden;

    background-color: ${0};

    border: 1px solid ${0};

    border-radius: 4px;

    box-shadow: ${0};

    cursor: text;

    &:hover {
        border: 1px solid ${0};
        box-shadow: ${0};
    }

    .ovpn-input-leading-icon,
    .ovpn-input-flag {
        margin-right: -8px;
        margin-left: 16px;

        color: ${0};
    }

    .ovpn-input-trailing-icon {
        margin-right: 16px;
        margin-left: -8px;

        color: ${0};
    }

    ${0};

    transition: box-shadow 150ms;
`), colors.neutralWhite, colors.neutralBorder, shadows.xs, colors.neutralBorder, shadows.sm, colors.neutralTextSubtitle, colors.neutralTextSubtitle, selectContainerStateStyles);
export const Prefix = styled.div(_t8 || (_t8 = _`
    ${0}

    border-right: 1px solid ${0};
`), affixStyle, colors.neutralBorder);
export const Suffix = styled.div(_t9 || (_t9 = _`
    ${0}

    border-left: 1px solid ${0};
`), affixStyle, colors.neutralBorder);